import styled from '@emotion/styled';
import Logo from './Logo';
import { colors, fonts, layout } from './theme';

const FooterRoot = styled.footer`
  background: ${colors.coreBlue};
  padding: clamp(40px, 5vw, 56px) 0 32px;
`;

const FooterInner = styled.div`
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 32px);
`;

const Divider = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  margin-top: 32px;
  padding-top: 24px;
`;

const BottomRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  font-family: ${fonts.mono};
  font-size: 12px;
  letter-spacing: 0.06em;
  color: ${colors.footerMuted};
  text-transform: uppercase;
`;

const Links = styled.div`
  display: flex;
  gap: 24px;
`;

const FooterLink = styled.a`
  color: ${colors.textInverseSecondary};
  text-decoration: none;

  &:hover {
    color: ${colors.baselineWhite};
  }
`;

export default function Footer() {
  return (
    <FooterRoot>
      <FooterInner>
        <Logo href="/" height={24} />
        <Divider />
        <BottomRow>
          <span>&copy; {new Date().getFullYear()} Pixels AI Ltd. All rights reserved</span>
          <Links>
            <FooterLink href="/contact/">Contact</FooterLink>
            <FooterLink href="https://wearecreatormedia.com/privacy-policy/">
              Privacy Policy
            </FooterLink>
          </Links>
        </BottomRow>
      </FooterInner>
    </FooterRoot>
  );
}
